import { render, staticRenderFns } from "./profileStats.vue?vue&type=template&id=0d0b6493&scoped=true&"
import script from "./profileStats.vue?vue&type=script&lang=js&"
export * from "./profileStats.vue?vue&type=script&lang=js&"
import style0 from "./profileStats.vue?vue&type=style&index=0&id=0d0b6493&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0b6493",
  null
  
)

export default component.exports